import { ContactInfoModel } from "@fs/models/customer/contact.info.model";
import { CodeTypeModel } from "@fs/models/code-type.model";
import { BillingDetailModel } from "@fs/models/customer/billing-detail.model";

export class JobSiteDetailModel {
  public SiteID: string;
  public ID: string;
  public CustomerID: string;
  public Type: CodeTypeModel;
  public IsActive: boolean;
  public FirstName: string;
  public LastName: string;
  public CompanyName: string;
  public DisplayName: string;
  public StreetNo: string;
  public City: string;
  public Unit: string;
  public State: string;
  public ZipCode: string;
  public ServiceArea: any;
  public TaxGroup: any;
  public SiteClass: any;
  public ModifyDate: any;
  public Comment: string;
  public IsAddressVerified: boolean;
  public IsAllowedOnTablet: boolean;
  public Contacts: ContactInfoModel[];
  public IntegrationStatus: string;
  public Latitude: string;
  public Longitude: string;
  public Customer: BillingDetailModel;
  public JobsiteSince: string;
  public MappingID: string;
  public constructor() {
    this.SiteID="",
    this.ID="",
    this.CustomerID="",
    this.IsActive=false,
    this.FirstName="",
    this.LastName="",
    this.CompanyName="",
    this.DisplayName="",
    this.StreetNo="",
    this.City="",
    this.Unit="",
    this.State="",
    this.ZipCode="",
    this.IsAddressVerified=false,
    this.IsAllowedOnTablet=true,
    this.Type = new CodeTypeModel(),
    this.ServiceArea = { ID: "" },
    this.TaxGroup = { ID: "" },
    this.SiteClass = { ID: "" },
    this.Comment = "",
    this.Contacts = [],
    this.IntegrationStatus  = "",
    this.JobsiteSince="",
    this.MappingID=""
  }
}

export class JobSiteModel {
    public ID: string;
    public jobSiteId: string;
    public Type: CodeTypeModel;
    public FirstName: string;
    public LastName: string;
    public CompanyName: string;
    public DisplayName: string;
    public StreetNo: string;
    public City: string;
    public Unit: string;
    public State: string;
    public ZipCode: string;
    public ServiceArea: any;
    public TaxCode: any;
    public SiteClass: any;
    public Contacts: ContactInfoModel[];
    public IsAddressVerified: boolean;
    public IsAllowedOnTablet: boolean;

    public constructor() {
        this.ID = "";
        this.jobSiteId = "";
        this.FirstName = "";
        this.LastName = "";
        this.CompanyName = "";
        this.DisplayName = "";
        this.StreetNo = "";
        this.Unit = "";
        this.City = "";
        this.State = "";
        this.ZipCode = "";
        this.TaxCode = "";
    }
}